import { render, staticRenderFns } from "./IT.vue?vue&type=template&id=1c6bdbdf&scoped=true&"
import script from "./IT.vue?vue&type=script&lang=ts&"
export * from "./IT.vue?vue&type=script&lang=ts&"
import style0 from "./IT.vue?vue&type=style&index=0&id=1c6bdbdf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6bdbdf",
  null
  
)

/* custom blocks */
import block0 from "./IT.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCol,VRow})
